import React from 'react';
import DataViewer from './DataViewer';

function App() {
  return (
    <div className="App">
      <DataViewer />
    </div>
  );
}

export default App;